import React, { useState, useEffect, useRef } from 'react';
import MobileFilterCollapse from '../../components/common/form/MobileFilterCollapse';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Divider,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  ToggleButtonGroup,
  ToggleButton,
  Typography,
} from '@mui/material';
import { getYears } from '../../utils/constCodeUtils';
import * as xlsx from 'xlsx';
import AskDialog from '../../components/common/dialog/AskDialog';
import ObtainorderStaticsHqContainer from './ObtainorderStaticsHqContainer';
import ObtainorderStaticsTeamContainer from './ObtainorderStaticsTeamContainer';
import ObtainorderStaticsEmp from './ObtainorderStaticsEmp';
const arrYears = getYears(3, 1);
const arrMonths = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
];

const prjTypOptions = [
  { value: 'A', name: '전체' },
  { value: 'N', name: '프로젝트' },
  { value: 'M', name: '유지보수' },
];

const staticsTypes = [
  { name: '본부', type: 'headquarter' },
  { name: '팀', type: 'depart' },
  { name: '팀원', type: 'employee' },
];

const ObtainorderStaticsContainer = () => {
  const hqTableRef = useRef();
  const dpTableRef = useRef();
  const empTableRef = useRef();

  const [searchPrjTyp, setSearchPrjTyp] = useState('A');
  const [type, setType] = useState('headquarter');
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedStrMonth, setSelectedStrMonth] = useState('01');
  const [selectedEndMonth, setSelectedEndMonth] = useState('12');
  const [searchData, setSearchData] = useState(null);

  const handleChangeType = (event, newType) => {
    if (newType === '' || newType === null) {
      newType = 'headquarter';
    }
    setType(newType);
    searchClickHandler();
  };

  const handleChangePrjTyp = (event, newPrjTyp) => {
    if (newPrjTyp === '' || newPrjTyp === null) {
      newPrjTyp = 'A';
    }
    setSearchPrjTyp(newPrjTyp);
    searchClickHandler();
  };

  const [visible, setVisible] = useState(false);
  const onCancle = () => {
    setVisible(false);
  };

  const onConfirm = () => {
    setVisible(false);
  };

  const checkValid = () => {
    let valid = true;
    if (parseInt(selectedStrMonth) > parseInt(selectedEndMonth)) {
      valid = false;
    }

    return valid;
  };

  useEffect(() => {
    if (
      type &&
      searchPrjTyp &&
      selectedYear &&
      selectedStrMonth &&
      selectedEndMonth
    ) {
      setSearchData(
        type +
          '_' +
          searchPrjTyp +
          '_' +
          selectedYear +
          '-' +
          selectedStrMonth +
          '~' +
          selectedEndMonth,
      );
    }
  }, [searchPrjTyp, selectedEndMonth, selectedStrMonth, selectedYear, type]);

  const searchClickHandler = () => {
    const valid = checkValid();
    if (!valid) {
      setVisible(true);
      return;
    }
    setSearchData(
      type +
        '_' +
        searchPrjTyp +
        '_' +
        selectedYear +
        '-' +
        selectedStrMonth +
        '~' +
        selectedEndMonth,
    );
  };

  const handleDownExcel = () => {
    let el;
    let name;
    if (type === 'headquarter') {
      el = hqTableRef;
      name = '본부';
    } else if (type === 'depart') {
      el = dpTableRef;
      name = '팀';
    } else if (type === 'employee') {
      el = empTableRef;
      name = '팀원';
    }
    htmlToExcel(el.current, name);
  };

  const htmlToExcel = (tableEl, name) => {
    const wb = xlsx.utils.table_to_book(tableEl, {
      sheet: 'sheet1',
      raw: true,
    });
    xlsx.writeFile(wb, name + '.xlsx');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', my: 2 }}>
      <MobileFilterCollapse summary={`${selectedYear}년 ${selectedStrMonth}~${selectedEndMonth}월`}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          id="search-daterange"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            // 휴대폰 폭에서는 줄을 바꿔 쌓고, '년/월부터/까지' 글자가 한 글자씩 꺾이지 않게 한다(2026-10-08 모바일 점검).
            flexWrap: 'wrap',
            rowGap: 1,
            '& .MuiTypography-subtitle2': { whiteSpace: 'nowrap' },
            '& .MuiFormLabel-root': { whiteSpace: 'nowrap' },
          }}
        >
          <Box sx={{ minWidth: 100, mx: 0.5 }}>
            <FormControl variant="standard" size="small" fullWidth>
              <Select
                labelId="selected-year-label"
                id="selected-year"
                value={selectedYear}
                displayEmpty
                label="년도"
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                {arrYears &&
                  arrYears.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ mx: 0.5 }}>
            <Typography variant="subtitle2">년</Typography>
          </Box>
          <Box sx={{ minWidth: 80, mx: 0.5 }}>
            <FormControl variant="standard" size="small" fullWidth>
              <Select
                labelId="start-month-label"
                id="selected-month"
                value={selectedStrMonth}
                displayEmpty
                label="시작월"
                onChange={(e) => setSelectedStrMonth(e.target.value)}
              >
                {arrMonths.map((month, index) => (
                  <MenuItem key={index} value={month}>
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ mx: 0.5 }}>
            <Typography variant="subtitle2">월부터</Typography>
          </Box>
          <Box sx={{ minWidth: 80, mx: 0.5 }}>
            <FormControl variant="standard" size="small" fullWidth>
              <Select
                labelId="end-month-label"
                id="end-month"
                value={selectedEndMonth}
                displayEmpty
                label="종료월"
                onChange={(e) => setSelectedEndMonth(e.target.value)}
              >
                {arrMonths.map((month, index) => (
                  <MenuItem
                    key={index}
                    value={month}
                    disabled={parseInt(selectedStrMonth) > parseInt(month)}
                  >
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ mx: 0.5 }}>
            <Typography variant="subtitle2">까지</Typography>
          </Box>
          <Box sx={{ mx: 1 }}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="prjTyp-radion-label"
                name="prjTyp-group"
                value={searchPrjTyp}
                onChange={handleChangePrjTyp}
              >
                {prjTypOptions &&
                  prjTypOptions.map((option, index) => (
                    <FormControlLabel
                      key={option.value}
                      value={option.value}
                      control={<Radio />}
                      label={option.name}
                    />
                  ))}
              </RadioGroup>
            </FormControl>
          </Box>
          <Box sx={{ mx: 1 }}>
            <ToggleButtonGroup
              size="small"
              color="primary"
              value={type}
              exclusive
              onChange={handleChangeType}
            >
              {staticsTypes.map((type, index) => (
                <ToggleButton key={index} value={type.type}>
                  {type.name}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box sx={{ mx: 1 }}>
            <Button
              variant="contained"
              color="info"
              onClick={searchClickHandler}
            >
              검색
            </Button>
          </Box>
          <Box>
            <Button
              variant="contained"
              color="success"
              onClick={handleDownExcel}
            >
              엑셀 다운로드
            </Button>
          </Box>
        </Box>
      </Box>
      </MobileFilterCollapse>
      <Divider sx={{ my: 1 }} />
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        {type === 'headquarter' && (
          <ObtainorderStaticsHqContainer
            type={type}
            selectedYear={selectedYear}
            strMonth={selectedStrMonth}
            endMonth={selectedEndMonth}
            selectPrjTyp={searchPrjTyp}
            searchData={searchData}
            tableRef={hqTableRef}
          />
        )}
        {type === 'depart' && (
          <ObtainorderStaticsTeamContainer
            type={type}
            selectedYear={selectedYear}
            strMonth={selectedStrMonth}
            endMonth={selectedEndMonth}
            selectPrjTyp={searchPrjTyp}
            searchData={searchData}
            tableRef={dpTableRef}
          />
        )}
        {type === 'employee' && (
          <ObtainorderStaticsEmp
            type={type}
            selectedYear={selectedYear}
            strMonth={selectedStrMonth}
            endMonth={selectedEndMonth}
            selectPrjTyp={searchPrjTyp}
            searchData={searchData}
            tableRef={empTableRef}
          />
        )}
      </Box>

      <AskDialog
        visible={visible}
        title="검색 오류"
        description="잘못된 검색기간이 설정되었습니다. 검색기간을 확인하세요"
        confirmText="확인"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </Box>
  );
};
export default ObtainorderStaticsContainer;
